import { DatePipe, registerLocaleData } from '@angular/common';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE, OwlDateTimeModule, OwlNativeDateTimeModule, OwlDateTimeIntl } from 'ng-pick-datetime';

import { AnpiService } from './../_services/anpi-code.service';
import { TranslateService } from '../_services/translate.service';
import { TranslatePipe } from '../_pipes/translate.pipe';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { HeaderComponent } from './pages/layout/header/header.component';
import { FooterComponent } from './pages/layout/footer/footer.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { EmployeesComponent } from './pages/employees/employees.component';
import { HttpClientModule, HTTP_INTERCEPTORS  } from '@angular/common/http';
import { CnssComponent } from './pages/cnss/cnss.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { FaqComponent } from './pages/faq/faq.component';
import { NotificationComponent } from './pages/notification/notification.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { DependenceComponent } from './pages/dependence/dependence.component';
import { ExperienceComponent } from './pages/experience/experience.component';
import { CnssReportsComponent } from './pages/cnss-reports/cnss-reports.component';
import { SalaryReviseComponent } from './pages/salary-revise/salary-revise.component';
import { GetStartedComponent } from './pages/get-started/get-started.component';
import { LinkBusinessComponent } from './pages/link-business/link-business.component';
import { CnssReportsListComponent } from './pages/cnss-reports-list/cnss-reports-list.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { PaymentComponent } from './pages/payment/payment.component';
import { CnssReportViewComponent } from './pages/cnss-report-view/cnss-report-view.component';
import { MatButtonModule,MatSnackBarModule,MatDatepickerModule,MatNativeDateModule,MAT_DATE_LOCALE, MatRadioModule, MatSelectModule, MatCheckboxModule, MatFormFieldModule, MatInputModule, MatAutocompleteModule, MatIconModule } from '@angular/material';
import { CnssApprovalFormComponent } from './pages/cnss-approval-form/cnss-approval-form.component';
import { AddBankComponent } from './pages/add-bank/add-bank.component';
import { ContactFloatingComponent } from './pages/layout/contact-floating/contact-floating.component';
import { OnboardingPortalComponent } from './pages/layout/onboarding-portal/onboarding-portal.component';
import { DependenceListComponent } from './pages/dependence-list/dependence-list.component';
import { CnamgsFormComponent } from './pages/cnamgs-form/cnamgs-form.component';
import { CnamgsReportComponent } from './pages/cnamgs-report/cnamgs-report.component';
import { CnamgsReportlistComponent } from './pages/cnamgs-reportlist/cnamgs-reportlist.component';
import { CnamgsReportviewComponent } from './pages/cnamgs-reportview/cnamgs-reportview.component';
import { NgxUiLoaderModule, NgxUiLoaderConfig, SPINNER, POSITION,
  PB_DIRECTION, NgxUiLoaderRouterModule, NgxUiLoaderHttpModule } from 'ngx-ui-loader';
import { BasicAuthInterceptor, ErrorInterceptor } from '../_helpers';
import { MainLayoutComponent } from './pages/layout/main-layout/main-layout.component';
import { BusinessListComponent } from './pages/business-list/business-list.component';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { EmployeeCnamgsComponent } from './pages/employee-cnamgs/employee-cnamgs.component';
import { N404Component } from './pages/n404/n404.component';
import { VerificationComponent } from './pages/verification/verification.component';
import { EmployeeHistoryComponent } from './pages/employee-history/employee-history.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { environment } from '../environments/environment';
import { MessagingService } from '../_services/messaging.service';
import { FamilyAllowanceComponent } from './pages/family-allowance/family-allowance.component';
import { FamilyAllowanceListComponent } from './pages/family-allowance-list/family-allowance-list.component';
import { FamilyAllowanceViewComponent } from './pages/family-allowance-view/family-allowance-view.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import {GoTopButtonModule} from 'ng2-go-top-button';
import localeFr from '@angular/common/locales/fr';
import { InvoiceVerificationComponent } from './pages/invoice-verification/invoice-verification.component';
import { VerifyEmployerComponent } from './pages/verify/verify-employer/verify-employer.component';
import { EmployeeTerminationComponent } from './pages/employee-termination/employee-termination.component';

registerLocaleData(localeFr, 'fr');

  const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: 'yellow',
  // bgsOpacity: 0.5,
  // bgsPosition: POSITION.bottomCenter,
   bgsSize:420,
  // bgsType: SPINNER.rectangleBounce,
  fgsColor: 'white',
  // fgsPosition: POSITION.centerCenter,
   fgsSize: 200,
   fgsType: SPINNER.ballScaleMultiple,
  // logoUrl: 'assets/angular.png',
  pbColor: '#004e9a',
  // pbDirection: PB_DIRECTION.leftToRight,
   pbThickness: 10,
  // text: 'Welcome to ngx-ui-loader',
  // textColor: '#FFFFFF',
  // textPosition: POSITION.centerCenter
   masterLoaderId: "master"
}; 

export function setupTranslateFactory(
  service: TranslateService): Function {
  return () => service.use(localStorage.getItem('language') || "fr");
}
export const MY_CUSTOM_FORMATS = {
  fullPickerInput: 'YYYY-MM-DD',
  monthYearLabel: 'MMMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY'
};
@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    HeaderComponent,
    FooterComponent,
    HomePageComponent,
    EmployeesComponent,
    CnssComponent,
    TranslatePipe,
    ContactUsComponent,
    FaqComponent,
    NotificationComponent,
    ProfileComponent,
    DependenceComponent,
    ExperienceComponent,
    CnssReportsComponent,
    SalaryReviseComponent,
    GetStartedComponent,
    LinkBusinessComponent,
    CnssReportsListComponent,
    PaymentComponent,
    CnssReportViewComponent,
    CnssApprovalFormComponent,
    AddBankComponent,
    ContactFloatingComponent,
    OnboardingPortalComponent,
    DependenceListComponent,
    CnamgsFormComponent,
    CnamgsReportComponent,
    CnamgsReportlistComponent,
    CnamgsReportviewComponent,
    MainLayoutComponent,
    BusinessListComponent,
    EmployeeCnamgsComponent,
    N404Component,
    VerificationComponent,
    EmployeeHistoryComponent,
    FamilyAllowanceComponent,
    FamilyAllowanceListComponent,
    FamilyAllowanceViewComponent,
    InvoiceVerificationComponent,
    VerifyEmployerComponent,
    EmployeeTerminationComponent
  ],
  imports: [
    GoTopButtonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    FormsModule,
    GooglePlaceModule,
    AngularFireModule.initializeApp(environment.firebaseConfig, 'ccps-cnamgs-admin'),
    AngularFireAuthModule,
    AngularFireMessagingModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    OwlDateTimeModule,
    MatPaginatorModule,
    OwlNativeDateTimeModule, MatButtonModule,MatSnackBarModule, MatRadioModule, MatSelectModule, MatCheckboxModule, MatFormFieldModule, MatInputModule, MatAutocompleteModule,
     ],
  providers: [
    TranslateService,
    DatePipe,
    MessagingService,
    AnpiService,
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: APP_INITIALIZER, useFactory: setupTranslateFactory, deps: [ TranslateService ], multi: true },
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'fr'},
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
